
@if (isLoading) {
  <div class="app-page" style="margin-left: 10px; margin-right: 10px;">
    <mat-toolbar>
      <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back_ios_new</mat-icon>
      </button>
      {{"SCOUTING.NEW_REPORT" | translate}}
    </mat-toolbar>
    <div style="padding: 20px; text-align: center;">
      <p>{{"SCOUTING.LOADING_PLAYER_DATA" | translate}}</p>
    </div>
  </div>
} @else if (loadError) {
  <div class="app-page" style="margin-left: 10px; margin-right: 10px;">
    <mat-toolbar>
      <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back_ios_new</mat-icon>
      </button>
      {{"SCOUTING.NEW_REPORT" | translate}}
    </mat-toolbar>
    <div style="padding: 20px; text-align: center;">
      <p>{{"SCOUTING.LOAD_PLAYER_DATA_FAILED" | translate}}</p>
      <button mat-raised-button (click)="back()">{{"SCOUTING.GO_BACK" | translate}}</button>
    </div>
  </div>
} @else if (this.Player) {
  <div class="app-page" style="margin-left: 10px; margin-right: 10px;">
     <mat-toolbar>
      <button mat-icon-button (click)="back()">
        <mat-icon>
          arrow_back_ios_new
        </mat-icon>
      </button>
      {{"SCOUTING.NEW_REPORT" | translate}}
    
    </mat-toolbar>
    
    <mat-divider></mat-divider>
   
    <app-player-header style="margin-left: 20px;" [Player]="this.Player"></app-player-header>
    <mat-divider></mat-divider>
  
    @if (this.Game) {
      <app-game-header-small style="margin-left: 20px;" [Game]="this.Game.Game"></app-game-header-small>
    }
    <mat-divider></mat-divider>
    <h2>
      {{"SCOUTING.GENERAL" | translate}}
    </h2>
    <!--   <div>
    {{this.reportForm.value | json}}
  </div> -->
  @if (this.ReportMasterData) {
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
      <input type="hidden" formControlName="PlayerId"/>
      <input type="hidden" formControlName="GameId"/>
      <mat-form-field class="wideinput" >
        <mat-label>{{"SCOUTING.GAME_PERFORMANCE" | translate}}</mat-label>
        <mat-select #gameperformance  formControlName="GamePerformance">
          <mat-select-trigger>
            <span [ngStyle]="{'background-color': this.gameperf_colors[gameperformance?.value]} ">&nbsp;&nbsp;</span>
            {{this.gameperf_texts[gameperformance?.value]}}
          </mat-select-trigger>
          <mat-option [value]="1">
            <span style="background-color: #ff2c1c; ">&nbsp;&nbsp;</span>
            {{"SCOUTING.BAD" | translate}}
          </mat-option>
          <mat-option [value]="2">
            <span style="background-color: #e9c400; ">&nbsp;&nbsp;</span>
            {{"SCOUTING.AVERAGE" | translate}}
          </mat-option>
          <mat-option [value]="3">
            <span style="background-color: yellowgreen; ">&nbsp;&nbsp;</span>
            {{"SCOUTING.GOOD" | translate}}
          </mat-option>
          <mat-option [value]="4">
            <span style="background-color: limegreen; ">&nbsp;&nbsp;</span>
            {{"SCOUTING.VERY_GOOD" | translate}}
          </mat-option>
          <mat-option [value]="5">
            <span style="background-color: #1e90ff; ">&nbsp;&nbsp;</span>
            {{"SCOUTING.EXCELLENT" | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      @if (this.PlayerPositions) {
        <mat-form-field appearance="fill" class="wideinput">
          <mat-label>Position</mat-label>
          <mat-select #PositionId formControlName="PositionId">
            @for (pos of this.PlayerPositions; track pos) {
              <mat-option [value]="pos.PlayerPositionId">
                {{pos.Text}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <br/>
      @if (this.ReportMasterData.CapacityEnabled) {
      <mat-form-field class="wideinput" >
        <mat-label >{{"SCOUTING.PLAYER_CAPACITY" | translate}}</mat-label>
        <mat-select #Capacity formControlName="Capacity">
       <!--    <mat-select-trigger>
            <span [ngStyle]="{'background-color': this.getCapacityColor(Capacity?.value)} ">&nbsp;&nbsp;</span>
            {{this.getCapacityText(Capacity?.value)}}
          </mat-select-trigger> -->
          @for (cap of this.ReportMasterData.Capacity; track cap.Ranking) {
            <mat-option [value]="cap.Ranking">
              <span [style.background-color]="getCapacityColor(cap.Ranking)">&nbsp;&nbsp;</span>
              {{cap.Text}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      @if (this.ReportMasterData.PlayerTypeEnabled) {
        <mat-form-field appearance="fill" class="wideinput">
          <mat-label>{{"SCOUTING.PLAYER_TYPE" | translate}}</mat-label>
          <mat-select formControlName="PlayerType">
            @for (plyrtype of this.ReportMasterData.PlayerType; track plyrtype.Ranking) {
              <mat-option [value]="plyrtype.Ranking">
                {{plyrtype.Text}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <br/>
      @if (this.ReportMasterData.CurrentLevelEnabled) {
        <mat-form-field class="wideinput" >
          <mat-label>{{"SCOUTING.CURRENT_LEVEL" | translate}}</mat-label>
          <mat-select #CurrentLevel formControlName="CurrentLevelRanking">
            <mat-select-trigger>
              <span [ngStyle]="{'background-color': this.getCurrentLevelColor(CurrentLevel?.value)} ">&nbsp;&nbsp;</span>
              {{this.getCurrentLevelText(CurrentLevel?.value)}}
            </mat-select-trigger>
            @for (cl of this.ReportMasterData.CurrentLevel; track cl.Ranking) {
              <mat-option [value]="cl.Ranking">
                <span [style.background-color]="cl.Color">&nbsp;&nbsp;</span>
                {{cl.Text}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field class="wideinput" >
        <mat-label>{{"SCOUTING.PROJECTION" | translate}}</mat-label>
        <mat-select #Projection formControlName="Projection" placeholder="{{'SCOUTING.PROJECTION' | translate}}">
          <mat-select-trigger>
            <span [ngStyle]="{'background-color': this.getProjectionColor(Projection?.value)} ">&nbsp;&nbsp;</span>
            {{this.getProjectionText(Projection?.value)}}
          </mat-select-trigger>
          @for (proj of this.ReportMasterData.Projection; track proj.Ranking) {
            <mat-option [value]="proj.Ranking">
              <span [ngStyle]="{'background-color': this.getProjectionColor(proj.Ranking)} ">&nbsp;&nbsp;</span>
              {{proj.Text}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <br/>
      <mat-form-field  appearance="fill"  class="widetextarea">
        <mat-label>{{"SCOUTING.COMMENT" | translate}}</mat-label>
        <textarea matInput cdkTextareaAutosize cdkTextareaAutosize
          cdkAutosizeMinRows="5"
        placeholder="{{'SCOUTING.ENTER_COMMENTS' | translate}}" formControlName="Comment"></textarea>
      </mat-form-field>
      <br/>
      <mat-form-field  appearance="fill"  class="wideinput">
        <mat-label>{{"SCOUTING.LOCATION" | translate}}</mat-label>
        <input matInput
          placeholder="{{'SCOUTING.LOCATION' | translate}}" formControlName="Location">
        </mat-form-field>

        @if (this.ReportMasterData.ScoutingSource.length>0) {
          <mat-form-field appearance="fill" class="wideinput">
            <mat-label>Source</mat-label>
            <mat-select #ScoutingSourceId formControlName="ScoutingSourceId">
              @for (source of this.ReportMasterData.ScoutingSource; track source) {
                <mat-option [value]="source.ScoutingSourceId">
                  {{source.Text}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        
        <mat-form-field  appearance="fill"  class="wideinput">
          <input matInput [matDatepicker]="picker" formControlName="ReportDate">
          <mat-label>{{"SCOUTING.REPORT_DATE" | translate}}</mat-label>
          <mat-hint style="color: gray;">YYYY-MM-DD</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-divider></mat-divider>
        <h2>{{"SCOUTING.SKILLS" | translate}}</h2>
        <div formArrayName="SkillGroups">
          @for (group of this.ReportMasterData.SkillsGroupsView; track group; let i = $index) {
            <div >
              <div [formGroupName]="i">
                <div style="font-weight: bold; ">
                  <mat-icon>workspaces</mat-icon>
                  {{group.Text}}
                </div>
                <div style="margin-left: 10px;" formArrayName="Skills">
                  <!--  <app-skill-ranking *ngFor="let skill of group.Skills; "  [SkillText]="skill.Text" [SkillId]="skill.SkillId"></app-skill-ranking> -->
                  @for (skill of group.Skills; track skill; let skillindex = $index) {
                    <div [formGroupName]="skillindex" class="skill-row">
                      <div class="skill-header-row">
                        <div class="skill-name">{{skill.Text}}</div>
                        <div class="skill-selected-text">{{ getSkillValueText(i, skillindex) }}</div>
                      </div>
                      <div class="skill-slider-row">
                        <app-rating-slider5 formControlName="Value" ></app-rating-slider5>
                        <!--  <mat-button-toggle-group formControlName="Value" >
                        <mat-button-toggle *ngFor="let op of mylist"
                          [value]="op"          >
                          [ngClass]="{'bg-bad': this['selected'+skill.SkillId] === 1,'bg-average':this['selected'+skill.SkillId] === 2,'bg-good':this['selected'+skill.SkillId] === 3,'bg-verygood':this['selected'+skill.SkillId] === 4,'bg-excellent':this['selected'+skill.SkillId] === 5}"
                          (click)="this['selected'+skill.SkillId] = op;" >  -
                          <div  style="font-size: small; line-height: 22px;display: flex; flex-direction: column;">
                            <div>
                              {{op}}
                            </div>
                            <div>
                              {{getText(op) }}
                            </div>
                          </div>
                        </mat-button-toggle>
                      </mat-button-toggle-group> -->
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      <button mat-raised-button type="submit" color="primary" [disabled]="!this.reportForm.valid">SAVE</button>
      &nbsp;
      <button type="button" mat-button (click)="goBack()">BACK</button>
    </form>
  }
</div>
}

